<template>
  <div id="totalBox">
    <transition name="fade">
      <div class="carouselBox">
        <div class="bannerBox homeBanner" v-show="imgShow">
          <img :src='img1' class="homeBannerImg" alt="" />
        </div>
        <div class="bannerBox ckBanner" v-show="!imgShow">
          <img :src='img2' class="homeBannerImg" alt=""/>
        </div>
      </div>
    </transition>
    <transition name="slider">
      <ul class="dotBox">
        <li class="dots" :class="{activeDot:type==1}" data-type='1' @click="changeBanner"></li>
        <li class="dots" :class="{activeDot:type==2}" data-type='2' @click="changeBanner"></li>
      </ul>
    </transition>
  </div>
</template>

<script>
import bannerIMG from '@/assets/home/banner.jpg'
import ckBannerIMG from '@/assets/home/ckBanner.jpg'
export default {
  name: 'carousel',
  data: function () {
    return {
      img1: bannerIMG,
      img2: ckBannerIMG,
      imgShow: true,
      type: 1,
      intervals: 0
    }
  },
  created: function () {
    this.sendType()
  },
  methods: {
    sendType: function () {
      this.$emit('transferColorType', this.type)
    },
    changeBanner: function (e) {
      console.log(e.currentTarget.dataset.type)
      if (e.currentTarget.dataset.type === '1') {
        if (this.type !== 1) {
          this.type = 1
          this.imgShow = true
          this.sendType()
          clearInterval(this.intervals)
          this.setInterval()
        }
      } else if (e.currentTarget.dataset.type === '2') {
        if (this.type !== 2) {
          this.type = 2
          this.imgShow = false
          this.sendType()
          clearInterval(this.intervals)
          this.setInterval()
        }
      }
    },
    setInterval: function () {
      var self = this
      this.intervals = setInterval(function () {
        self.imgShow = !self.imgShow
        if (self.imgShow) {
          self.type = 1
        } else {
          self.type = 2
        }
        self.sendType()
      }, 8000)
    }
  },
  mounted: function () {
    this.setInterval()
  }
}
</script>

<style scoped>
 #totalBox{
   position: relative;
 }
.carouselBox{
  width: 100%;
}
.bannerBox{
  width: 100%;
  padding-top: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.homeBanner{
  background-color: RGBA(255, 182, 30, 1);
}
.ckBanner{
  background-color: RGBA(61, 59, 79, 1);
}
.homeBannerImg{
  width: 1200px;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 6s
}
.fade-enter, .fade-leave-to{
  opacity: 0
}
.dotBox{
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: 20px;
  list-style: none;
  padding: 0;
}
.dots{
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #fff;
  margin:0 5px;
  cursor: pointer;
}
.activeDot{
  width: 50px;
}
.silder-enter-active, .silder-leave-active {
  transition: all 2s
}
.silder-enter, .silder-leave-to{
  opacity: 0
}
</style>



// WEBPACK FOOTER //
// src/components/home/carousel.vue